import { Backdrop } from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { common_axios } from "../../../App";
import Loader from "../../../components/Loader";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

export default function ResellerAdmin() {
  const customId1 = "custom-id-yess";
  const [open, setOpen] = React.useState(false);
  const [resllerCartList, setresllerCartList] = useState([]);
  const [response, setresponse] = useState("");
  const [getId, setgetId] = useState([]);
  const [sum, setsum] = useState(0);
  const [total, setTotal] = useState(0);
  const [amountity, setamountity] = useState(0);
  const [adminId, setadminId] = useState(0);

  const getProducts = async () => {
    try {
      setOpen(true);

      const res = await common_axios(
        `${
          process.env.REACT_APP_COMMON_API_REWARDS
        }/reward/v1/reseller/addToCart/list/${localStorage.getItem("UserId")}`
      );
      if (res.data.statusDescription.statusCode == 200) {
        setresponse(res.data.statusDescription.statusMessage);
        setresllerCartList(res?.data?.resellerCartList);
        setOpen(false);
        let vall = 0;

        // setPackType(res.data.rewardProductList);
        // await setStatus("approved");

        for (let index = 0; index < res.data.resellerCartList.length; index++) {
          const element = res.data.resellerCartList[index];
          console.log("EEE", element.amount);
          vall += (await Number(element.amount)) * element.quantity;
        }

        let aster = 0;
        for (let index = 0; index < res.data.resellerCartList.length; index++) {
          const element = res.data.resellerCartList[index];
          console.log("EEE", element.quantity);
          aster += await element.quantity;

          console.log(aster, "aster");
        }

        // let valll = total;
        // for (let index = 0; index < res.data.resellerCartList.length; index++) {
        //   const element = res.data.resellerCartList[index];
        //   console.log("EEE", element.quantity);
        //   valll *= await element.quantity;
        // }

        // for (let i = 0; i < res?.data?.resellerCartList?.length; i++) {
        //   const element = res?.data?.resellerCartList[i];
        //   console.log("EEE", element.amount);
        //   vall += await element.amount;
        // }
        setadminId(aster);

        setTotal(vall);
        // setamountity(valll);
        await toast.success({
          theme: "colored",
          toastId: customId1,
          toastId: customId1,
        });
      } else if (res.data.statusDescription.statusCode == 220) {
        setTotal(0);
        setadminId(0);
        setresllerCartList([]);
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
          toastId: customId1,
          toastId: customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
          toastId: customId1,
          toastId: customId1,
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
        toastId: customId1,
        toastId: customId1,
      });
    }
  };

  console.log({ response });

  console.log({ total });
  console.log({ amountity });
  React.useEffect(() => {
    getProducts();
  }, []);

  console.log(resllerCartList);

  const deleteProduct = async (e, resp) => {
    // alert(adminId);
    try {
      console.log(e);
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_REWARDS}/reward/v1/reseller/addToCart/delete`,
        {
          id: resp,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        await getProducts();
        setOpen(false);
        await toast.success("Product deleted", {
          theme: "colored",
          toastid: customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
          toastid: customId1,
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong ! Please check your network", {
        theme: "colored",
        toastid: customId1,
      });
    }
  };
  const paymentConfirm = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_REWARDS}/payment/v1/confirm`,
        {
          productId: 2,
          userId: localStorage.getItem("UserId"),
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        await toast.success("Product deleted", {
          theme: "colored",
          toastid: customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
          toastid: customId1,
        });
      }
    } catch (error) {
      setOpen(false);
      await toast.error("Something went wrong ! Please check your network", {
        theme: "colored",
        toastid: customId1,
      });
    }
  };
  return (
    <>
      {" "}
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>

        <div class="container-fluid">
          <div class="row">
            <div class="col-md-9 mb-xl-0 mb-4">
              <div class="card mb-3">
                <div class="card-header p-3 pt-2">
                  <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <ShoppingCartIcon
                      sx={{ color: "white", fontSize: "33px" }}
                    />
                  </div>
                  <div class="">
                    <p
                      className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                      style={{ marginLeft: "70px" }}
                    >
                      Cart Details
                    </p>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div className="text-end ">
                        <button className="btn btn-primary  ">
                          <Link className="text-white" to="/dashboard/rewards">
                            Back To Rewards
                          </Link>
                        </button>
                      </div>
                      <div>
                        <div className="">
                          <h4 className="text-capitalize">cart</h4>
                          <p className="text-capitalize text-end price my-3">
                            price
                          </p>

                          {resllerCartList == null ||
                          resllerCartList.length > 0 ? (
                            resllerCartList.map((resop, index) => {
                              return (
                                <div
                                  key={index}
                                  className="d-flex justify-content-between align-items-center my-3"
                                >
                                  <div
                                    className="card p-4"
                                    style={{ border: " 2px solid #b1d3e7" }}
                                  >
                                    <h6>{resop?.productName}</h6>
                                    <div class="flt_8">
                                      <div class="d-flex align-items-center float-start">
                                        <span class="d-block text-capitalize qty">
                                          qty :{resop?.quantity}
                                        </span>
                                        <button
                                          type="button"
                                          class="btn btn-primary m-0 mx-2"
                                          onClick={() => {
                                            deleteProduct(
                                              index,

                                              resop.addToCartId
                                            );
                                          }}
                                        >
                                          <DeleteIcon />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <h5 class="">
                                    {" "}
                                    ₹{Number(resop?.amount) * resop?.quantity}
                                  </h5>
                                </div>
                              );
                            })
                          ) : (
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-12">
                                  <div>
                                    <div className="">
                                      <h4>No Products Added</h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="bg_white p-4">
                <div className="text-align-center">
                  <div className="fw-bold">Purchase Summary</div>
                  <div className="fw-bold">Total Quantity : {adminId}</div>
                  <p className="text-capitalize fw-bold m-0">
                    subtotal: ₹{total}
                  </p>
                </div>
                <button
                  type="button"
                  class="btn bg-gradient-primary m-0 mt-3 d-block w-100"
                  //   onClick={paymentConfirm}
                  disabled={resllerCartList.length < 0}
                >
                  Buy Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
